import { useMemo } from "react";

import { typedQueryClient } from "hooks/useTypedQuery";
import { KioskDashboardQueryKeys } from "modules/KioskDashboard/queryKeys";

import type { WebSocketMessageListener } from "components";
import type { KioskLabel } from "models";

export const useKioskLabelsListeners = () => {
  const listeners = useMemo(() => {
    const kioskListeners: WebSocketMessageListener<KioskLabel>[] = [
      {
        model: "KioskLabel",
        action: "upsert",
        callback: ({ data: kioskLabelUpdate }) => {
          const kioskLabels = typedQueryClient.getQueryData(KioskDashboardQueryKeys.labels);
          if (!kioskLabels) return;

          const kioskLabelIdx = kioskLabels.findIndex(label => label.id === kioskLabelUpdate.id);

          typedQueryClient.setQueryData(
            KioskDashboardQueryKeys.labels,
            kioskLabelIdx === -1 ? [...kioskLabels, kioskLabelUpdate] : kioskLabels.with(kioskLabelIdx, kioskLabelUpdate)
          );
        }
      }
    ];

    return [...kioskListeners];
  }, []);

  return listeners;
};
